// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StarOutlinedSvg from "@fishx/icons-svg/es/asn/StarOutlined";
import FishxIcon from '../components/FishxIcon';

var StarOutlined = function StarOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: StarOutlinedSvg
  }));
};

StarOutlined.displayName = 'StarOutlined';
export default React.forwardRef(StarOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/StarOutlined.js
// module id = 4188
// module chunks = 0